import {NewsletterSection} from "./NewsletterSection/NewsletterSection";
import {VisitsSection} from "./VisitsSection/VisitsSection";
import {ReviewsSection} from "./ReviewsSection/ReviewsSection";
import {OrdersSection} from "./OrdersSection/OrdersSection";
import {UsersSection} from "./UsersSection/UsersSection";
import {SimpleCrudSection} from "./crud_tables/crud_tables";
import {ProductsSection} from "./ProductsSection/ProductsSection";
import {useTranslation} from "react-i18next";
import {Tab} from "./dashboardTabs";

export const AdminContent = ({ tab }: { tab: Tab }) => {
    const { t } = useTranslation();

    switch (tab) {
        case 'products':
            return <ProductsSection />;

        case 'collections':
            return (
                <SimpleCrudSection
                    endpoint="/collections"
                    label={t('admin.dashboard.collection')}
                />
            );

        case 'categories':
            return (
                <SimpleCrudSection
                    endpoint="/categories"
                    label={t('admin.dashboard.category')}
                />
            );

        case 'home-sliding-photos':
            return (
                <SimpleCrudSection
                    endpoint="/home-sliding-photos"
                    label={t('admin.dashboard.home-sliding-photos')}
                />
            );

        case 'users':
            return <UsersSection />;

        case 'orders':
            return <OrdersSection />;

        case 'reviews':
            return <ReviewsSection />;

        case 'visits':
            return <VisitsSection />;

        case 'newsletter':
            return <NewsletterSection />;

        default:
            return null;
    }
};
